import { useTranslation } from "@shared/utils/internationalization";
import { WILL_CALL_DISPLAY_LABEL_MAP } from "../data/types";
import { useCachedBrandingConfig } from "./useCachedBrandingConfig";

export function useWillCallLabel(): string {
  const brandingConfig = useCachedBrandingConfig();
  const { t } = useTranslation("common");
  const key = brandingConfig?.branding_will_call_display_label ?? "will_call";
  return t(WILL_CALL_DISPLAY_LABEL_MAP[key].labelKey);
}
